import { InterestVariable } from '../../../../api/dashboard-agility/DashboardAgility.types'

const DROPDOWN_KEY_TO_INTEREST_VARIABLE: Record<string, InterestVariable | null> = {
	volumeTotalComCasca: InterestVariable.VOLUME_TOTAL_COM_CASCA,
	volumeTotalSemCasca: InterestVariable.VOLUME_TOTAL_SEM_CASCA,
	arvoresMedVolumeTotalComCasca: InterestVariable.VOLUME_INDIVIDUAL_COM_CASCA,
	arvoresMedVolumeTotalSemCasca: InterestVariable.VOLUME_INDIVIDUAL_SEM_CASCA,
	imaComCasca: InterestVariable.INCREMENTO_MEDIO_ANUAL_COM_CASCA,
	imaSemCasca: InterestVariable.INCREMENTO_MEDIO_ANUAL_SEM_CASCA,
	areaBasal: InterestVariable.AREA_BASAL,
	dg: InterestVariable.DIAMETRO_MEDIO_QUADRATICO,
	dapMaximo: InterestVariable.DAP_MAXIMO,
	dapMedio: InterestVariable.DAP_MEDIO,
	dapMinimo: InterestVariable.DAP_MINIMO,
	alturaMaxima: InterestVariable.ALTURA_TOTAL_MAXIMA,
	alturaMedia: InterestVariable.ALTURA_TOTAL_MEDIA,
	alturaMinima: InterestVariable.ALTURA_TOTAL_MINIMA,
	alturaDominante: InterestVariable.ALTURA_DOMINANTE,
	numeroDeFustes: InterestVariable.NUMERO_DE_FUSTES,
	arvoresUteis: InterestVariable.NUMERO_DE_FUSTES_UTEIS,
	proporcaoArvoresUteis: InterestVariable.PROPORCAO_DE_FUSTES_UTEIS,
}

export const mapDropdownKeyToInterestVariable = (
	dropdownKey: string | null | undefined,
): InterestVariable | null => {
	if (!dropdownKey) return null
	return DROPDOWN_KEY_TO_INTEREST_VARIABLE[dropdownKey] ?? null
}
